import { useEffect, useState } from 'react'

import { useAutomations } from '../../Contexts/AutomationsContext'
import ModelsSelector from './ModelsSelector'

const ActivationRuleForm = ({ trigger, isEdit, onChange, selectedOrganizationKey, validation, readonly }) => {
  const {
    quantityId = trigger.quantity?.id || trigger.quantityId,
    selectedModels = trigger.models,
    applyToChildOrganizations,
    type,
    organizationKey
  } = trigger

  const { useGetQuantities } = useAutomations()

  const [quantities, setQuantities] = useState([])
  const [selectedQuantity, setSelectedQuantity] = useState()

  useEffect(() => {
    useGetQuantities(selectedOrganizationKey).then((res) => {
      setQuantities(res.data)
      setSelectedQuantity(res.data.find((q) => q.id === quantityId))
    })
  }, [])

  useEffect(() => {
    const selected = quantities.find((q) => q.id === quantityId)
    setSelectedQuantity(selected)
  }, [quantityId])

  const handleModelsChanged = (data) => onChange(data)

  return (
    <>
      <ModelsSelector
        applyToChildOrganizations={applyToChildOrganizations}
        type={type}
        selectedModels={selectedModels}
        selectedQuantity={selectedQuantity}
        isEdit={isEdit}
        onModelsChanged={handleModelsChanged}
        selectedOrganizationKey={organizationKey || selectedOrganizationKey}
        validation={validation}
        readonly={readonly}
      />
    </>
  )
}

export default ActivationRuleForm
